import React, { Component } from 'react';
import { Row, Col, Icon, Divider, Button, Modal, Select, Input, Table, 
         message, DatePicker, Typography, Dropdown, Menu } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { getCookie } from '../../../hook';
import './style.css';


import { 
    save_letter,
    get_users,
    get_letter,
    delete_letter,
    block_letter,
    update_RequestingFor,
    update_address,
    update_purpose,
    update_remarks,
    update_date } from './actions/letter.action';

const dateFormat = 'YYYY/MM/DD';
const Option = Select.Option;
const { TextArea } = Input;
const { confirm } = Modal;
let timer,x;
const { Paragraph } = Typography;

class RequestLetter extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            users_list: [],
            new_visible: false,
            current_user_type: '',
            current_user: 0,
            requesting_for: '',
            address_to: '',
            purpose: '',
            remarks: '',
            request_date: '',
            request_fliter: [
                { text: 'Salary Certificate', value: 'Salary Certificate' },
                { text: 'Salary Transfer Letter', value: 'Salary Transfer Letter' },
                { text: 'NOC', value: 'NOC' },
                { text: 'Recommendation Letter', value: 'Recommendation Letter' },
                { text: 'Undertaking Letter', value: 'Undertaking Letter' },
            ]
        }

        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
        this.handleDelete = this.handleDelete.bind( this );
        this.handleBlock = this.handleBlock.bind( this );
        this.handleUpdateRequestingFor = this.handleUpdateRequestingFor.bind( this );
        this.handleUpdateAddress = this.handleUpdateAddress.bind( this );
        this.handleUpdatePurpose = this.handleUpdatePurpose.bind( this );
        this.handleUpdateRemarks = this.handleUpdateRemarks.bind( this );
        this.handleUpdateDate = this.handleUpdateDate.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );
        this.handleMenuClick = this.handleMenuClick.bind( this );

    }

    handleMenuClick( e, forWhat, id ){
        
        if( e.key === '2' ){

            if( forWhat === 'Employment Certificate' ){
                this.props.history.push( '/prints/dv-employment-certificate/' + id );
            }

            if( forWhat === 'Salary Certificate Account' ){
                this.props.history.push( '/prints/dv-salary-certificate-acc/' + id );
            }
            
            if( forWhat === 'Undertaking Letter' ){
                this.props.history.push( '/prints/undertaking-letter/' + id );
            }

            if( forWhat === 'Recommendation Letter' ){
                this.props.history.push( '/prints/recommendation-letter/' + id );
            }

            if( forWhat === 'Salary Transfer Letter' ){
                this.props.history.push( '/prints/dv-salary-trans-certificate/' + id );
            }

            if( forWhat === 'Salary Certificate' ){
                this.props.history.push( '/prints/dv-salary-certificate/' + id );
            }
            
            if( forWhat === 'Salary Slip' ){
                this.props.history.push( '/prints/payslip/' + id );
            }

        } else {
            this.props.history.push( '/prints/letter/' + id );
        }


    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleUpdateDate( id, value ){
        this.props.update_date( id, value );
    } 

    handleUpdateRemarks( id, value ){
        this.props.update_remarks( id, value );    
    }

    handleUpdatePurpose( id, value ){
        this.props.update_purpose( id, value );    
    }

    handleUpdateAddress( id, value ){
        this.props.update_address( id, value );    
    }

    handleUpdateRequestingFor( id, value ){
        this.props.update_RequestingFor( id, value );
    }

    handleBlock( id, value ){

        let data = 0;

        if( value === '1' ){
            data = 0;
        } else {
            data = 1;
        }

        this.props.block_letter( id, data );

    }

    handleDelete( id ){
        let self = this;

        confirm({
            title: 'Do you want to delete?',
            onOk() {
                self.props.delete_letter( id );
            },
            onCancel() {
                // Nothing
            },
        });

    }

    handleSubmit(){

        let temp = {
            user_id: this.state.current_user,
            requesting_for: this.state.requesting_for,
            address_to: this.state.address_to,
            purpose: this.state.purpose,
            remarks: this.state.remarks,
            request_date: this.state.request_date
        }

        if( this.state.requesting_for !== '' &&
            this.state.address_to !== '' &&
            this.state.purpose !== '' &&
            this.state.request_date !== '' ){

            this.props.save_letter( temp );

        } else {

            message.error( 'All fields are mandatory' );

        }

    }

    handleCancel(){
        this.setState({ new_visible: false });
    }

    componentDidMount(){

        let let_id = 'all';
        if( this.props.match.params.id ){
            let_id = this.props.match.params.id;
        }
        
        let user = getCookie('dv_hrms_user').split(',');
        this.props.get_users();
        this.props.get_letter( user[6], let_id );

        this.setState({
            current_user: user[1],
            current_user_type: user[3]
        });

    }

    componentWillReceiveProps( nextProps ){

        let let_id = 'all';
        if( this.props.match.params.id ){
            let_id = this.props.match.params.id;
        }

        if( nextProps.letter.length !== 0 ){

            if( nextProps.letter.STATUS.CODE === "200" &&
                nextProps.letter.STATUS.MESSAGE === "Successfully Listed Res Users" ){
                this.setState({
                    users_list: nextProps.letter.OUTPUT.DATA
                })
            }

            if( nextProps.letter.STATUS.CODE === "200" &&
                nextProps.letter.STATUS.MESSAGE === "Successfully Saved New Application" ){
                this.setState({ 
                    requesting_for: '',
                    address_to: '',
                    purpose: '',
                    remarks: '',
                    request_date: '',
                    new_visible: false });

                let user = getCookie('dv_hrms_user').split(',');
                this.props.get_letter( user[6], let_id );

            }

            if( nextProps.letter.STATUS.CODE === "200" &&
                nextProps.letter.STATUS.MESSAGE === "Successfully Listed Applications" ){
                this.setState({
                    data: nextProps.letter.OUTPUT.DATA
                })
            }

            if( nextProps.letter.STATUS.CODE === "200" &&
                nextProps.letter.STATUS.MESSAGE === "Successfully Deleted" ){
                let user = getCookie('dv_hrms_user').split(',');
                this.props.get_letter( user[6], let_id );

            }

            if( nextProps.letter.STATUS.CODE === "200" &&
                nextProps.letter.STATUS.MESSAGE === "Successfully Updated" ){
                let user = getCookie('dv_hrms_user').split(',');
                this.props.get_letter( user[6], let_id );
                message.success( nextProps.letter.STATUS.MESSAGE );
            }

            
            if( nextProps.letter.STATUS.CODE === "400" ){
                message.error( nextProps.resignation.STATUS.MESSAGE );
            }

        }

    }

    render() {

        const columns = [
            {
                title: 'Employee',
                key: 'full_name',
                dataIndex: 'full_name',
                width: '15%',
                ...this.getColumnSearchProps( 'full_name' )
            },{
                title: 'Requesting For',
                key: 'requesting_for',
                width: '15%',
                filters: this.state.request_fliter,
                onFilter: (value, record) => record.requesting_for.indexOf(value) === 0,
                render: ( data ) => <span>
                    <Select
                        disabled={ (  data.block === '1' ) ? true : false }
                        showSearch
                        value={ data.requesting_for }
                        onChange={(value)=> this.handleUpdateRequestingFor( data.request_letter_id, value ) }
                        style={{ width: '100%' }}>
                        <Option key="Salary Certificate">Salary Certificate</Option>
                        <Option key="Salary Certificate Account">Salary Certificate Acct Confirmation</Option>
                        <Option key="Salary Transfer Letter">Salary Transfer Letter</Option>
                        <Option key="Salary Slip">Salary Slip</Option>
                        <Option key="NOC">NOC</Option>
                        <Option key="Recommendation Letter">Recommendation Letter</Option>
                        <Option key="Undertaking Letter">Undertaking Letter</Option>
                        <Option key="Employment Certificate">Employment Certificate</Option>
                    </Select>
                </span>
            },{
                title: 'Address To',
                key: 'address_to',
                width: '15%',
                ...this.getColumnSearchProps( 'address_to' ),
                render: ( data ) => <span>
                    <Paragraph 
                        disabled={ (  data.block === '1' ) ? true : false }
                        editable={ ( data.block !== '1' ) ? { onChange: ( str ) => this.handleUpdateAddress(  data.request_letter_id, str ) } : false }>
                        { data.address_to }
                        </Paragraph>
                </span>
            },{
                title: 'Purpose',
                key: 'purpose',
                width: '15%',
                ...this.getColumnSearchProps( 'purpose' ),
                render: ( data ) => <span>

                    <Paragraph 
                        disabled={ (  data.block === '1' ) ? true : false }
                        editable={( data.block !== '1' ) ? { onChange: ( str ) => this.handleUpdatePurpose(  data.request_letter_id, str ) } : false }>
                        { data.purpose }
                        </Paragraph>

                </span>
            },{
                title: 'remarks',
                key: 'remarks',
                width: '15%',
                render: ( data ) => <span>

                    <Paragraph 
                        disabled={ (  data.block === '1' ) ? true : false }
                        editable={ ( data.block !== '1' ) ? { onChange: ( str ) => this.handleUpdateRemarks(  data.request_letter_id, str ) } : false }>
                        { data.remarks }
                        </Paragraph>

                </span>
            },{
                title: 'Date',
                key: 'request_date',
                width: '12%',
                render: ( data ) => <DatePicker
                    style={{ width: '100%' }}
                    defaultValue={moment( data.request_date, dateFormat )}
                    onChange={ ( date, dateString ) => this.handleUpdateDate( data.request_letter_id, dateString ) }
                    disabled={ (  data.block === '1' ) ? true : false } />
            },{
                title: 'Actions',
                key: 'actions',
                width: '20%',
                render: ( data ) => <span>
                    
                    <Dropdown trigger={['click']} overlay={
                        <Menu onClick={ ( e )=> this.handleMenuClick( e, data.requesting_for, data.request_letter_id )  }>
                            <Menu.Item key="2"><Icon type="printer" />Print Letter</Menu.Item>
                            <Menu.Item key="1"><Icon type="printer" />Print Request</Menu.Item>
                        </Menu>
                    }>
                        <Button size="small" type="primary" style={{ marginRight: '5px' }} >
                            Print <Icon type="down" />
                        </Button>
                    </Dropdown>

                    <Button size="small" icon="delete" type="danger"
                        disabled={ (  data.block === '1' ) ? true : false }
                        onClick={ ()=> this.handleDelete( data.request_letter_id )  } />
                    {
                         ( this.state.current_user_type === 'admin' ) ? 
                         <Button size="small" icon="stop" type="primary" style={{ marginLeft: '5px' }}
                            onClick={ ()=> this.handleBlock( data.request_letter_id, data.block ) } /> : ''
                    }
                </span>
            }
        ]
        
        const users_list = this.state.users_list.map( (item, k ) => <Option key={ item.user_id }>{ item.full_name }</Option> )

        return (
            <div className="letter_wrapper">
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="file-text" />
                            &nbsp; Letter Application Form
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ ()=> this.setState({ new_visible: true }) }
                            className="fl_right" 
                            type="primary" >New Application</Button>

                    </Col>
                </Row>
                
                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Table columns={ columns } dataSource={ this.state.data } />
                    </Col>
                </Row>

                
                {/* New */}
                <Modal
                    title="Letter Application Form"
                    maskClosable={ false }
                    visible={ this.state.new_visible }
                    onOk={ this.handleSubmit }
                    onCancel={ this.handleCancel }>
                    <Row>
                        <Col span={24}>

                        { ( this.state.current_user_type === 'admin' ) ? <Row>
                                <Col span={24} className="mrg_b_15">
                                    <label>Select Employee</label>
                                    <Select
                                        showSearch
                                        style={{width: '100%'}}
                                        value={this.state.current_user}
                                        onChange={ (value) => this.setState({ current_user: value }) }
                                        filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }>
                                        { users_list }
                                    </Select>
                                </Col>
                            </Row> : ''  }

                            <Row>
                                <Col span={24} className="mrg_b_10">
                                    <label>Requesting for:</label>
                                    <Select
                                        showSearch
                                        onChange={(value)=> this.setState({ requesting_for: value })}
                                        value={ this.state.requesting_for }
                                        style={{ width: '100%', marginBottom: '10px' }}>
                                        <Option key="Salary Certificate">Salary Certificate</Option>
                                        <Option key="Salary Certificate Account">Salary Certificate Acct Confirmation</Option>
                                        <Option key="Salary Transfer Letter">Salary Transfer Letter</Option>
                                        <Option key="Salary Slip">Salary Slip</Option>
                                        <Option key="NOC">NOC</Option>
                                        <Option key="Recommendation Letter">Recommendation Letter</Option>
                                        <Option key="Undertaking Letter">Undertaking Letter</Option>
                                        <Option key="Employment Certificate">Employment Certificate</Option>
                                    </Select>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="mrg_b_10">
                                    <label>Addressed to (Bank/Company/Facility/Agency):</label>
                                    <TextArea rows={2}
                                        onChange={ (e) => this.setState({ address_to: e.target.value }) }
                                        value={this.state.address_to}
                                        style={{ width: '100%' }} />
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="mrg_b_10">
                                    <label>Purpose:</label>
                                    <TextArea rows={2}
                                        onChange={ (e) => this.setState({ purpose: e.target.value }) }
                                        value={this.state.purpose}
                                        style={{ width: '100%' }} />
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="mrg_b_10">
                                    <label>Additional Remarks (specific details you want to add in the letter):</label>
                                    <TextArea rows={2} 
                                        onChange={ (e) => this.setState({ remarks: e.target.value }) }
                                        value={this.state.remarks}
                                        style={{ width: '100%' }} />
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="mrg_b_10">
                                    <label>Date:</label>
                                    <DatePicker
                                        style={{ width: '100%' }} 
                                        defaultValue={ moment( this.state.date , dateFormat ) }
                                        onChange={( date, dateString ) => this.setState({ request_date: dateString })} />
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Modal>

            </div>
        )
    }
}


function mapStateToProps( state ) {
    return {
        letter: state.letter
    }
}

export default connect( mapStateToProps, { 
    save_letter,
    get_users,
    get_letter,
    delete_letter,
    block_letter,
    update_RequestingFor,
    update_address,
    update_purpose,
    update_remarks,
    update_date })( RequestLetter );


// WEBPACK FOOTER //
// ./src/pages/requests/letter/index.js